// Superficie (subdominio) activa. El MISMO build sirve varias superficies acotadas:
// mi.eneural.org (panel), billing., recaudacion. y clientes. El host decide cuál.
export function surfaceFromHost(host) {
  const h = host || '';
  if (h.startsWith('clientes.'))    return 'clientes';
  if (h.startsWith('recaudacion.')) return 'recaudacion';
  if (h.startsWith('billing.'))     return 'billing';
  return 'panel';
}

export const SURFACE_DEFAULTS = {
  clientes:    '/clientes-v2',
  recaudacion: '/recaudacion',
  billing:     '/billing',
  panel:       '/dashboard',
};

// Roles dedicados que NO viven en el panel: cada uno tiene su dominio acotado.
export const SUBDOMINIO_POR_ROL = {
  sac:       'https://clientes.eneural.org',
  contratos: 'https://contratos.eneural.org',
};

// Superficie "propia" de cada rol dedicado dentro de ESTE bundle (dónde NO se lo expulsa).
// sac vive en clientes.eneural.org (que sirve este mismo bundle). contratos NO tiene
// entrada acá: contratos.eneural.org corre un bundle aparte, así que un token 'contratos'
// que caiga en cualquier superficie de ESTE bundle siempre se expulsa a su dominio.
const HOME_SURFACE = { sac: 'clientes' };

// A dónde expulsar a un rol dedicado que está en una superficie que NO es su casa. Cubre
// TODAS las superficies de este bundle (panel, billing, recaudacion, clientes), no solo el
// panel: billing./recaudacion. también sirven este build y un rol dedicado no debe quedarse
// ahí. En su propia casa (sac en 'clientes') devuelve null -> sin redirect, sin loop.
// Roles no dedicados -> null.
export function destinoExpulsion(surface, role) {
  const destino = SUBDOMINIO_POR_ROL[role];
  if (!destino) return null;
  if (surface === HOME_SURFACE[role]) return null;
  return destino;
}
